import React, { Component } from 'react'
import './Stores.css'
import { connect } from 'react-redux'
import * as languageSettings from '../Language/languageSettings'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
import t from '../Language/language'
import NavigationService from '../Common/NavigationServices'
import { CommonConstants } from '../../Constants'
import { checkAccess, getPermission } from '../../actions/permissions'
import { bindActionCreators } from 'redux'
import { confirmAlert } from 'react-confirm-alert'

import moment from 'moment'

class RemoteSystemActions extends Component {
  constructor (props) {
    super(props)
    this.state = {
      systemActions: this.props.systemActions,
      currentLanguage: languageSettings.getCurrentLanguage(),
      isPerformDeviceRestart: false
    }
    this.navigate = new NavigationService()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.token = this.authService.getToken()
    this.renderRemoteActionsForClientUser = this.renderRemoteActionsForClientUser.bind(this)
    this.confirm = this.confirm.bind(this)
    this.props.getPermission()
    // this.props.getUpgradeDate(props.deviceUid)
  }

  masterSettings () {
    window.location.href = '/stores/masterSettings?duid=' + this.props.deviceUid
  }
  confirm (method, subVersion = '') {
    let self = this
    let actionMessage = (method === 'upgrade' ? 'Upgrade System' : (method === 'reboot' ? 'Reboot System' : (method === 'reconnect' ? 'Force Reconnect' : '')))
    confirmAlert({
      // title: t[this.state.currentLanguage]['ConfirmationRequired'],
      // message: 'Are you sure you would like to initiate a ' + actionMessage.toLowerCase() + ' on this system?',
      // buttons: [
      //   {
      //     label: actionMessage + ' Now',
      //     onClick: () => {
      //       self.action(method)
      //     }
      //   },
      //   {
      //     label: 'Cancel',
      //     onClick: () => { }
      //   }
      // ]
      customUI: ({ onClose }) => {
        return (
          <div className='popup'>
            <p className='popup_Title'>{t[this.state.currentLanguage]['ConfirmationRequired']}</p>
            <p className='popup_message'>{'Are you sure you would like to initiate a ' + actionMessage.toLowerCase() + ' on this system?'}</p>
            {method === 'upgrade' ? <div className='Popup_message'>
              <span className='warningMsg'><strong className='warning'>WARNING:</strong> This action cannot be undone! Your system will be offline during the upgrade process for approximately 20 to 25 Minutes.</span>
            </div> : ''}
            <div className='popup_buttons'>
              <div className='buttonSet' />
              <div className='popup-button'>
                <button className='popup_buttons buttons' onClick={() => self.action(method, subVersion)}>{(actionMessage === 'Reboot System') ? 'Reboot' : actionMessage.charAt(0).toUpperCase() + actionMessage.slice(1)} Now</button>
                <button className='popup_buttons buttons' onClick={() => { onClose() }}>Close</button>
              </div>
            </div>
          </div>
        )
      }
    })
  }

  // render actions for admin portal
  renderRemoteActionsForAdmin () {
    let systemStatus = this.props.systemActions.systemStatus[0]
    let deviceUpgradeDate = this.props.systemActions.Device_LastUpgrade
    let currentServerTime = this.props.systemActions.Server_CurrentTime
    let upgrading = moment(currentServerTime.replace('Z', ''))
    let upgradeTime = 15
    if (deviceUpgradeDate !== undefined && deviceUpgradeDate !== null && deviceUpgradeDate !== '') {
      upgrading = moment(deviceUpgradeDate.replace('Z', ''))
    }

    if (systemStatus.Device_DeviceType_ID === 1) {
      upgradeTime = 30
    } else if (systemStatus.Device_DeviceType_ID === 4) {
      upgradeTime = 5
    } else if (systemStatus.Device_DeviceType_ID === 3) {
      upgradeTime = 10
    } else {
      upgradeTime = 15
    }

    return (
      <div className='RemoteSystemActions'>
        <div><h3 className='versions'>Remote System Actions</h3>
          {this.renderUpdgradeButton(upgrading, upgradeTime)}
        </div>
        <div id='reboot-content'>
          {this.renderRebootButton(upgrading, upgradeTime)}
        </div>
        <div id='reconnect-content'>
          {this.renderReconnectButton(upgrading, upgradeTime)}
        </div>
        {systemStatus.Device_Name !== 'CIB' &&
          systemStatus.Device_Name !== 'EOS' &&
          systemStatus.Device_Name !== 'ION' && (
          <div id='master-settings'>
            {this.renderMasterSettingButton(upgrading, upgradeTime)}
          </div>
        )}
      </div>
    )
  }

  renderUpdgradeButton (upgrading, upgradeTime) {
    let systemStatus = this.props.systemActions.systemStatus[0]
    let currentServerTime = this.props.systemActions.Server_CurrentTime
    let subVersion = '3.x'
    let mainVersion = systemStatus.Device_MainVersion
    const major = mainVersion.split('.')[1]
    let checkLen = (major > 9) ? 4 : 3
    let upgradableVersions = Config.upgradableDeviceVersionTypes
    let latestVersion = Config.upgradableDeviceVersionTypes[Config.upgradableDeviceVersionTypes.length - 1]
    let indexOfUpgradableVersion = upgradableVersions.indexOf(mainVersion.substring(0, checkLen))
    let localNow = currentServerTime ? moment(currentServerTime.replace('Z', '')) : moment()
    if (mainVersion.substring(0, 1) === '3') {
      subVersion = '3.x'
    } else {
      subVersion = '2.x'
    }

    if ((localNow.diff(upgrading, 'm') > upgradeTime) || (localNow.format('YYYY-MM-DDThh:mm:ss') === upgrading.format('YYYY-MM-DDThh:mm:ss'))) {
      if (indexOfUpgradableVersion > -1 && mainVersion.substring(0, 1) === '3') {
        if (latestVersion !== mainVersion) {
          return (
            <div className='ActionButtons' >
              <select className='select-upgrade' onChange={(e) => { this.confirm('upgrade', e.target.value) }}>
                <option disabled='disabled' selected='selected'>Select Upgrade Version</option>
                {
                  upgradableVersions.map((item, index) => {
                    const versionValue = `${item.split('.')[0]}.${item.split('.')[1]}`
                    if (index > indexOfUpgradableVersion) {
                      return <option value={versionValue}>ZOOM CU50 v{item}</option>
                    } else {
                      return ''
                    }
                  })
                }
              </select>
            </div>
          )
        } else {
          return <div className='ActionButtons' >System at Latest Version</div>
        }
      } else {
        return <div className='ActionButtons' onClick={() => { this.confirm('upgrade', subVersion) }}>Upgrade System</div>
      }
    } else {
      return <div className='ActionButtons' >Upgrade Currently Unavailable</div>
    }
  }

  renderRebootButton (upgrading, upgradeTime) {
    let currentServerTime = this.props.systemActions.Server_CurrentTime
    let localNow = moment(currentServerTime.replace('Z', ''))
    if ((localNow.diff(upgrading, 'm') > upgradeTime) || (localNow.format('YYYY-MM-DDThh:mm:ss') === upgrading.format('YYYY-MM-DDThh:mm:ss'))) {
      return <div className='ActionButtons' onClick={this.confirm.bind(this, 'reboot')}> Reboot System </div>
    } else {
      return <div className='ActionButtons' >Reboot Currently Unavailable</div>
    }
  }

  renderReconnectButton (upgrading, upgradeTime) {
    let currentServerTime = this.props.systemActions.Server_CurrentTime
    let localNow = moment(currentServerTime.replace('Z', ''))
    if ((localNow.diff(upgrading, 'm') > upgradeTime) || (localNow.format('YYYY-MM-DDThh:mm:ss') === upgrading.format('YYYY-MM-DDThh:mm:ss'))) {
      return <div className='ActionButtons' onClick={this.confirm.bind(this, 'reconnect')}> Force Reconnect </div>
    } else {
      return <div className='ActionButtons' >Reconnect Currently Unavailable</div>
    }
  }

  renderMasterSettingButton (upgrading, upgradeTime) {
    let currentServerTime = this.props.systemActions.Server_CurrentTime
    let localNow = moment(currentServerTime.replace('Z', ''))
    if ((localNow.diff(upgrading, 'm') > upgradeTime) || (localNow.format('YYYY-MM-DDThh:mm:ss') === upgrading.format('YYYY-MM-DDThh:mm:ss'))) {
      return <div className='ActionButtons' onClick={this.masterSettings.bind(this)}>Master Settings</div>
    } else {
      return <div className='ActionButtons' >Master Settings Currently Unavailable</div>
    }
  }

  action (method, subVersion = '3.x') {
    window.location.href = this.navigate.getMenu(method, this.props.deviceUid, subVersion)
  }

  // render actions for public portal
  renderRemoteActionsForClientUser () {
    const language = this.state.currentLanguage

    // check if admin has perform device restart permission
    if (checkAccess(CommonConstants.userPermissions.PerformDeviceRestart)) {
      return (
        <div className='RemoteSystemActions' >
          <div className='client_remote_action_btn_space'>
            <div className='client_remote_actionBtn' onClick={this.action.bind(this, 'reboot')}>
              <span>{t[language].settingsDevicesReboot}</span>
              <br /><span>{t[language].System}</span>
            </div>
          </div>
          <div className='client_remote_action_btn_space'>
            <div className='client_remote_actionBtn' onClick={this.action.bind(this, 'reconnect')}>
              <span>{t[language].settingsDevicesForce}</span>
              <br /><span>{t[language].settingsDevicesReconnect}</span>
            </div></div>
        </div>
      )
    } else {
      return (<div />)
    }
  }

  // Main render method.
  render () {
    return (
      <div>
        {this.authService.isAdmin() ? this.renderRemoteActionsForAdmin() : this.renderRemoteActionsForClientUser()}
      </div>
    )
  }
}
// Setting the state from a redux store.
function mapStateToProps (state) {
  return {
    storeViewDetails: state.viewDetails.storeViewDetails
  }
}
// Binding the actions.
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getPermission: getPermission
    }, dispatch
  )
}

export default connect(mapStateToProps, matchDispatchToProps)(RemoteSystemActions)



// WEBPACK FOOTER //
// ./src/components/Stores/RemoteSystemActions.js